// The job page can stop being ours while it is open: the manager archives the batch, or delivers
// our submission from Inspect. The back end then refuses everything the page tries with
// `jobClosed: true`, and filterResponse turns the first of those into this notification so the page
// closes itself instead of showing an error next to whichever button happened to be pressed.
//
// A module-level listener rather than a context, because filterResponse is a plain function called
// from every fetch in the app, including ones outside the React tree.

let listener = null;

export function onJobClosed(callback) {
	listener = callback;
	return () => {
		if (listener === callback) {
			listener = null;
		}
	};
}

export function jobClosed(message) {
	if (listener) {
		listener(message);
	}
}
